export default "__VITE_ASSET__BOeJUabd__"